export const CCourseFormats = {
  ONLINE: "online",
  IN_PERSON: "inPerson"
};
